import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function DomainMoveNotice({ initialOpen }: { initialOpen: boolean }) {
  const [open, setOpen] = useState(initialOpen);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="domain-move-title"
      aria-describedby="domain-move-description"
      PaperProps={{
        sx: {
          bgcolor: "var(--secondary-bg-color)",
          color: "var(--text-color)",
          border: "1px solid #f0db4f",
        },
      }}
    >
      <DialogTitle id="domain-move-title" sx={{ color: "#f0db4f" }}>
        Valheim Cooking is moving
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="domain-move-description" sx={{ color: "inherit" }}>
          Valheim Cooking will soon only be available at{" "}
          <a
            href="https://bugbusters.games/valheimcooking"
            target="_top"
            style={{ color: "inherit", overflowWrap: "anywhere" }}
          >
            https://bugbusters.games/valheimcooking
          </a>
          . Please update your bookmarks so you can keep using the site when the
          old address expires.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => setOpen(false)} sx={{ color: "#f0db4f" }}>
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
}
